module.exports = __webpack_public_path__ + "img/QRcode.8a3aea8.png";